import React from 'react';
import { NavLink } from 'react-router-dom';

export interface SubTabItem {
  label: string;
  to: string;
  end?: boolean;
}

interface Props {
  items: SubTabItem[];
}

const SubTabs: React.FC<Props> = ({ items }) => (
  <nav className="hf-tabstrip" role="tablist" aria-label="Sub-section navigation">
    {items.map(item => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.end}
        role="tab"
        className={({ isActive }) => (isActive ? 'on' : '')}
      >
        {item.label}
      </NavLink>
    ))}
  </nav>
);

export default SubTabs;
